import {
  Component,
  ViewEncapsulation,
  forwardRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationModalComponent } from '../../notification-modal.component';
import { CustomInputComponent } from '../../../custom-input/custom-input.component';
import { PrepaidCheckoutSummaryComponent } from '../prepaid-checkout-summary/prepaid-checkout-summary.component';
import { CashPresetButtonComponent } from '@shared/components/cash-preset-button/cash-preset-button.component';

/**
 * Create-payment-request checkout UI (summary, methods, Stripe, cash, link timer).
 * Logic stays on {@link NotificationModalComponent}; this component only holds the template.
 */
@Component({
  selector: 'app-notification-payment-checkout-layout',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CustomInputComponent,
    PrepaidCheckoutSummaryComponent,
    CashPresetButtonComponent,
  ],
  templateUrl: './payment-checkout-layout.component.html',
  styleUrls: ['../../notification-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class NotificationPaymentCheckoutLayoutComponent {
  readonly host = inject(
    forwardRef(() => NotificationModalComponent),
    { host: true }
  );
}
